import { render, staticRenderFns } from "./addvariety.vue?vue&type=template&id=38524cb6&scoped=true&"
import script from "./addvariety.vue?vue&type=script&lang=js&"
export * from "./addvariety.vue?vue&type=script&lang=js&"
import style0 from "./addvariety.vue?vue&type=style&index=0&id=38524cb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38524cb6",
  null
  
)

export default component.exports